<template>
  <div class="table-search">
    <div
      class="table-search-item"
      v-for="(searchItem, searchIndex) in searchList"
      :key="searchIndex"
      >
      <component :is="'search-'+searchItem.type" :propKey="searchItem.prop" :items="searchItem.items" 
      :isAsync="searchItem.isAsync" :asyncItems="searchItem.asyncItems" :asyncOptions="searchItem.asyncOptions" 
      v-model="searchForm[searchItem.prop]" @search="search" :attrs="searchItem.attrs" :isShopsSearch="searchItem.isShopsSearch"/> 
    </div>
    <div class="table-search-item">
      <el-date-picker
        v-model="operateTime"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        :picker-options="pickerOptions"
        :clearable="false"
      />
    </div>
    <div class="table-search-item">
      <el-checkbox v-model="searchForm.hasRetry" :true-label="1" :false-label="0" @change="handleRetryFlagChanged">
        参与“自动重试”商品
        <el-tooltip class="item" effect="dark" content="筛选参与“自动重试”逻辑而铺货成功的商品" placement="top">
          <em class="el-icon-question"></em>
        </el-tooltip>
      </el-checkbox>
    </div>
    <div class="table-search-item"><el-button @click="search" style="height:100%" type="primary">查询</el-button></div>
    <div class="table-search-item"><el-button @click="clear" style="height:100%">清空</el-button></div>
    <slot></slot>
  </div>
</template>

<script>
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary";
import {getDateStart, getDateEnd} from "@/pages/supplier/prod/log/util"
import { getStaffList } from '@servers/base/user/index.js';
import dayjs from 'dayjs';

export default {
  components: {
    SearchSelect,
    SearchInput,
  },
  data() {
    return {
      searchForm: {
        shopId: '',
        outerId: '',
        startTime: '',
        endTime: '',
        hasRetry: 0
      },
      staffList: [],
      operateTime: [
        getDateStart(),
        getDateEnd(),
      ], 

    }
  },
  created() {
    const prodLogRetryFlag = sessionStorage.getItem('prodLogRetryFlag');
    if (prodLogRetryFlag) {
      const hasRetry = parseInt(prodLogRetryFlag);
      this.searchForm.hasRetry = isNaN(hasRetry) ? 0 : hasRetry;
    }
  },
  computed: {
    query() {
      let _query = {}
      this.searchForm = {
        ...this.searchForm,
        startTime: this.operateTime[0],
        endTime: this.operateTime[1]
      }
      for (const key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          _query[key] = this.searchForm[key]
        }
      }
      if(_query.shopId) {
         _query.shopId = this.getShopIdByUserId(_query.shopId)
      }
      return _query
    },
    shops() {
      // return this.$store.getters.shops_all
      // const shopId = this.searchList.find(item => item.prop === 'shopId')
      // const shops_all = this.$store.getters.shops_all.map(shop => ({label: shop.shortTitle || shop.title, value: shop.id, icon: shop.icon}))
      return this.$store.getters.shops_all
    },
    searchList() {
      return [
        {prop: "shopId", type: 'select', attrs:{placeholder: '店铺', multiple: false}, items: this.shops, isShopsSearch: true},
        {prop: "publishStatus", type: 'select', attrs:{placeholder: '状态'}, items: prod_center_dictionary.PUBLISH_STATUS},
        {prop: "outerId", type: 'input', attrs: {placeholder: '款式编码'}},
        {prop: "staffIds", type: 'select', attrs:{placeholder: '铺货人', multiple:true }, asyncItems: this.staffList, isAsync:true, asyncOptions:{queryFn:this.getStaffIds,}},
      ]
    },
    pickerOptions() {
      const getTimeStampStart = () => {
        return dayjs().subtract(150, 'day').startOf('day')
      };

      const getTimeStampEnd = () => {
        return dayjs().endOf('day')
      };

      return {
        disabledDate(v) {
          return v.getTime() < getTimeStampStart() || v.getTime() > getTimeStampEnd()
        },
      };
    }

  },
  watch: {
    operateTime(newVal) {
      if(newVal == null) {
        this.operateTime = [getDateStart(),getDateEnd()]
      }
    }
  },
  methods: {
    method_getSearchForm() {
      return this.query
    },
    handleRetryFlagChanged(value) {
      sessionStorage.setItem('prodLogRetryFlag', value);
      this.search();
    },
    async getStaffIds(_params) {
      if(_params){
        _params.queryStaffName = _params?.queryText || '';
      }
      
      const res = await getStaffList(_params);
      if (res) {
        this.staffList = (res.list || []).map(item=>{
          item.label = item.accountName;
          item.value = item.id; // 铺货日志里面存储的是id，商品新增存储的是accountId，所以这里需要用id查询
          return item;
        })
      }
    },
    getShopIdByUserId(userId){
      return this.shops.find(shop => shop.userId === userId)?.id
    },
    search() {
      this.$emit('search', this.query)
    },
    clear() {
      this.operateTime = [
        getDateStart(),
        getDateEnd(),
      ], 
      this.searchForm = {
        shopId: '',
        outerId: '',
        startTime: '',
        endTime: ''
      }
      this.search();
    },
  }
}
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
    line-height: 28px;
  }

}
</style>
